import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom-v5-compat";

import { MODAL_ROUTES } from "routing/routes";
import loaderWithRetry from "seneca-common/utils/loaderWithRetry";

const UnlockDarkModeModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "unlock-dark-mode-chunk" */
        "features/dark-mode/components/UnlockDarkModeModal"
      )
  )
);

const ShareAssignmentModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "share-assignment-chunk" */
        "features/teachers/pages/assignment/modals/AssignmentShareModal"
      )
  )
);

const MultipleAssignmentShareModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "share-assignment-chunk" */
        "features/teachers/pages/assignment/modals/MultipleAssignmentShareModal"
      )
  )
);

const ManageStudentModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "manage-student-chunk" */
        "features/teachers/common/components/ManageStudentModal/ManageStudentModal"
      )
  )
);

const AssignmentStudentResultModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "assignment-student-result-chunk" */
        "features/teachers/pages/assignment/modals/AssignmentStudentResultModal"
      )
  )
);

const DeleteAssignmentModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "delete-assignment-chunk" */
        "features/teachers/pages/assignment/modals/DeleteAssignment"
      )
  )
);

const PreSpeedyMarkingModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "pre-speedy-marking-chunk" */
        "features/teachers/pages/assignment/modals/PreSpeedyMarkingModal/PreSpeedyMarkingModal"
      )
  )
);

const MarkingModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "marking-chunk" */
        "features/teachers/pages/assignment/modals/MarkingModal/MarkingModal"
      )
  )
);

export function ModalRoutes() {
  return (
    <Routes>
      <Route
        path={MODAL_ROUTES.UNLOCK_DARK_MODE.path}
        element={
          <Suspense>
            <UnlockDarkModeModal />
          </Suspense>
        }
      />
      <Route
        path={MODAL_ROUTES.SHARE_ASSIGNMENT.path}
        element={
          <Suspense>
            <ShareAssignmentModal />
          </Suspense>
        }
      />
      <Route
        path={MODAL_ROUTES.SHARE_ASSIGNMENTS.path}
        element={
          <Suspense>
            <MultipleAssignmentShareModal />
          </Suspense>
        }
      />
      <Route
        path={MODAL_ROUTES.MANAGE_STUDENT.path}
        element={
          <Suspense>
            <ManageStudentModal />
          </Suspense>
        }
      />
      <Route
        path={MODAL_ROUTES.ASSIGNMENT_STUDENT_RESULT.path}
        element={
          <Suspense>
            <AssignmentStudentResultModal />
          </Suspense>
        }
      />
      <Route
        path={MODAL_ROUTES.DELETE_ASSIGNMENT.path}
        element={
          <Suspense>
            <DeleteAssignmentModal />
          </Suspense>
        }
      />
      <Route
        path={MODAL_ROUTES.START_SPEEDY_MARKING.path}
        element={
          <Suspense>
            <PreSpeedyMarkingModal />
          </Suspense>
        }
      />
      <Route
        path={MODAL_ROUTES.MARKING.path}
        element={
          <Suspense>
            <MarkingModal />
          </Suspense>
        }
      />
    </Routes>
  );
}
